import DeleteIcon from "@mui/icons-material/Delete";
import ReactFlow, { Handle, Position } from "reactflow";

const OutputNode = ({ id, data, deleteNode }) => (
  <div
    className={`flex flex-col items-center justify-center w-[170px] h-[65px] rounded-md text-slate-100 border-none text-lg relative p-1 bg-gray-600`}
    // className="relative w-24 h-20 bg-red-600 text-white border-2 border-red-400 rounded-lg flex items-center justify-center shadow-md"
  >
    <span className="font-bold text-sm">Level Complete</span>
    <button
      onClick={() => deleteNode(id)}
      className="absolute top-0 right-0 text-center bg-red-600 text-white rounded-full w-5 h-5 flex items-center justify-center"
    >
      <DeleteIcon />
    </button>
    <Handle type="target" id="input" position={Position.Bottom} />
  </div>
);

export default OutputNode;
